import { render, staticRenderFns } from "./ReportSetting.vue?vue&type=template&id=271d0c37&scoped=true"
import script from "./ReportSetting.vue?vue&type=script&lang=js"
export * from "./ReportSetting.vue?vue&type=script&lang=js"
import style0 from "./ReportSetting.vue?vue&type=style&index=0&id=271d0c37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d0c37",
  null
  
)

export default component.exports